import { default as domainCatalogGrid } from './grid/store'
import { default as domainCatalogJoin } from './juncao/store'
import { default as domainCatalogGridGen } from './gerar-ofertas/store'

export default {
    domainCatalogGrid,
    domainCatalogJoin,
    domainCatalogGridGen
}
